'use client';
import { generateColorInvariants } from './generateColorInvariants/generateColorInvariants.js';

const DEFAULT_COLOR_INVARIANTS = {
    white: generateColorInvariants('255, 255, 255'),
    black: generateColorInvariants('0, 0, 0'),
    neutral: {
        950: '#0E0F11',
        920: '#1D222B',
        900: '#222A37',
        700: '#323D4D',
        500: '#27344B',
        300: '#505F79',
        100: '#7A869A',
        80: '#95A0B3',
        60: '#D0D6E1',
        50: '#DDE3ED',
        40: '#ECEFF5',
        30: '#F1F3F8',
        20: '#F6F8FC'
    }
};

export { DEFAULT_COLOR_INVARIANTS };
//# sourceMappingURL=defaultInvariants.js.map
